
import arrow from "../../Images/Components/DDarrow.png"
import { useState } from "react";
import "./Checklist.css"
import styles from "../DropDown.css/DropDown.module.css";

export interface CheckboxOption {
    label: string;
    value: string;
}

interface CheckboxListProps {
    options: CheckboxOption[];
    selectedValues: string[];
    onChange: (selected: string[]) => void;
    // onFormChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void; 
    label?: string;
    required?: boolean;
    error?: string;
}

const CheckboxList: React.FC<CheckboxListProps> = ({
    options, selectedValues, onChange, label, required, error }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleList = () => {
        setIsExpanded((prev) => !prev);
    };

    const handleToggle = (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
        const isSelected = selectedValues.includes(value);
        const updatedSelection = isSelected
            ? selectedValues.filter((v) => v !== value)
            : [...selectedValues, value];

        onChange(updatedSelection);
        // onFormChange(event);
    };

    return (
        <div className="checkbox-list inputContainer">
            {label && (
                <p className="inputLabel chckbx-input-label">
                    {label} {required && <span className="required">*</span>}
                </p>
            )}





            <div className="formInput">
                <div className="checklist-dd">
                    <p>
                        Please Select One
                    </p>
                    <div className="selectArrow" aria-hidden="true" onClick={toggleList}>
                        <img className="arrow" src={arrow} />
                    </div>
                </div>

                {/* <button onClick={toggleList}>
                    {isExpanded ? "Collapse List" : "Expand List"}
                </button> */}
                {isExpanded && (
                    options.map((option) => (
                        <label key={option.value} className="checkbox-item">
                            <input
                                className="checkbox"
                                type="checkbox"
                                checked={selectedValues.includes(option.value)}
                                onChange={(e) => handleToggle(e, option.value)}
                                name={option.value}
                            />
                            <span>{option.label}</span>
                        </label>
                    )))}
            </div>



            {error && <p className="inputError">{error}</p>}
        </div>
    );
};

export default CheckboxList;